import { render, staticRenderFns } from "./vModal.vue?vue&type=template&id=f70915e6"
import script from "./vModal.vue?vue&type=script&lang=js"
export * from "./vModal.vue?vue&type=script&lang=js"
import style0 from "./vModal.vue?vue&type=style&index=0&id=f70915e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports